import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Route, Routes } from 'react-router-dom';
import Footer from './Footer';
import TopNav from './TopNav';

export function ExternalLayout(props) {
    return (
        <>
            <div className="content bg-image">
                <div>
                    <TopNav />
                    <h2 className="font-bold section nav-header container col-7 ps-5">
                        <span className="color-blue">THE CLEAR</span> <span className="color-red">CHOICE</span>
                    </h2>
                </div>
                <Container className='justify-content-center'>
                    <Row className='justify-content-center'>
                        <Col className='col-auto mt-3'>
                            <div className='page'>
                                {props.children}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Footer />
        </>
    );

}

export const ExternalLayoutRoute = ({component: Component, ...rest}) => { 
    return (
        <Routes>
            <Route {...rest} element = {
                <ExternalLayout> 
                    <Component />
                </ExternalLayout> 
            } />
        </Routes>           
    )
}